//GeneratorFlag:[NoChange]
import Region from './region';

export default {Region}
export{Region}